import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const paginationSelectSx = {
  '& .MuiTablePagination-toolbar': {
    alignItems: 'center',
    minHeight: '44px',
    paddingLeft: '16px',
    paddingRight: '8px',
  },
  '& .MuiTablePagination-selectLabel': {
    margin: 0,
  },
  '& .MuiTablePagination-select': {
    border: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    borderRadius: '4px',
    paddingLeft: '8px',
    paddingRight: '28px !important',
    paddingTop: '0px',
    paddingBottom: '0px',
    height: '32px',
    lineHeight: '32px',
  },
  '& .MuiTablePagination-selectIcon': {
    right: '6px',
  },
};

export const styles = createTypedSxStyles({
  tablePagination: paginationSelectSx,
  paginationActions: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    margin: '0 32px'
  },
  paginationLabel: {
    wordSpacing: '4px',
    '& strong': {
      fontWeight: 600
    }
  }
});
